export const GOOGLE_MAPS_API_KEY = "AIzaSyCDW5iVZ3ERN5nMdtmVs3gBuXMK9GMjN2s";
